import { DISMISS_NOTIFICATION, DISPLAY_NOTIFICATION, NotificationActionTypes, NotificationsState } from './types';
import { RESET_GLOBAL_STATE, GlobalActionTypes } from '../types';
import { unknown } from '../actions';

const initialState: NotificationsState = [];

const reducer = (
  state = initialState,
  action: NotificationActionTypes | GlobalActionTypes = unknown(),
): NotificationsState => {
  switch (action.type) {
    case DISPLAY_NOTIFICATION: {
      const { payload } = action;
      return [...state, payload];
    }

    case DISMISS_NOTIFICATION: {
      const [, ...tailErrors] = state;
      return tailErrors;
    }
    case RESET_GLOBAL_STATE: {
      return initialState;
    }

    default:
      return state;
  }
};

export default reducer;
